import {Controller, useFormContext} from "react-hook-form";
import {MissingDocumentationInput, MissingDocumentTypeMap} from "../../domain";
import React, {memo} from "react";
import {DropdownMultiSelect} from "../../../../common";
import {SPLIT_DELIMITER, splitAndRemoveEmpty} from "../../../../placement/const";

type MissingDocumentsInputProps = {
    sending: boolean;
    required?: boolean | undefined;
    fieldName?: keyof MissingDocumentationInput | undefined;
    label?: string | undefined;
}

const MissingDocumentsInput = memo((
    {
        sending,
        required = true,
        fieldName = 'missingDocumentations',
        label = 'What Documentation is Missing?'
    }: MissingDocumentsInputProps
) => {

    const {
        control,
        watch,
        setValue,
        clearErrors,
        formState: {
            errors
        },
    } = useFormContext<MissingDocumentationInput>();

    return (
        <div className="w-full text-black-200 pb-2 text-base items-center">
            <div className="flex items-center">
                <div className="w-2/6 text-right">
                    {label}
                </div>
                <div className="w-3/6 ml-4 items-center">
                    <Controller
                        name={fieldName}
                        control={control}
                        rules={{
                            required: {
                                value: required,
                                message: 'Please select at least 1 value from the What Documentation is Missing? field before submitting'
                            },
                        }}
                        render={() =>
                            <DropdownMultiSelect
                                field={'missingDocumentations'}
                                options={Array.from(MissingDocumentTypeMap.keys())}
                                labelMapperFunc={(val) => MissingDocumentTypeMap.get(val)!!}
                                value={watch('missingDocumentations')}
                                disabled={sending}
                                showBadges={true}
                                width="w-auto"
                                minWidth="min-w-xlplus"
                                placeholder="Select documentation..."
                                onRemoveBadge={(doc) => {
                                    const currentDocs = splitAndRemoveEmpty(watch('missingDocumentations') || '');
                                    const updatedDocs = currentDocs.filter(d => d !== doc);
                                    setValue("missingDocumentations", updatedDocs.join(SPLIT_DELIMITER));
                                    clearErrors("missingDocumentations");
                                }}
                                setValue={(selected) => {
                                    setValue("missingDocumentations", splitAndRemoveEmpty(selected).join(SPLIT_DELIMITER))
                                    clearErrors("missingDocumentations");
                                }}
                            />
                        }
                    />
                </div>
            </div>
            
            { errors.missingDocumentations &&
                <div className="pt-2 flex w-full">
                    <div className="w-2/6">
                    </div>
                    <div className="w-3/6 text-sm ml-6 text-red-700">
                        Please select at least 1 value from the What Documentation is Missing? field before submitting
                    </div>
                </div>
            }
        </div>
    );
});

export default MissingDocumentsInput;